import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const VivasayamPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `


  <h1>விவசாய விஷயங்கள்</h1>
  <div class="color4">
<div class="svk2"> குறிப்பு:-  விவசாய சம்பந்தமான பூப்ரவேசம், உழவு, 
விதைவிதைத்தல், எருஇடுதல், கதிரறுத்தல், தானியம் சேமித்தல், 
தானியம் செலவிடுதல், ஆடு-மாடு வாங்க - விற்க, குளம் - 
கிணறு வெட்ட போன்ற அனைத்து விஷயங்களையும் 
பஞ்சாங்கத்தில் குறிப்பிட்டுள்ள நல்ல நாட்களிலேயே 
செய்வது காலம் காலமாக வழக்கத்தில் இருந்து வருகிறது.</div></div>
  
<div class="accordion"> 
  
  
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">1. பூப்ரவேசம்</div> </summary>
  திருவாதிரை, பூசம், மகம், உத்ரம், ஹஸ்தம்,  சித்திரை, ஸ்வாதி, அனுஷம், உத்ராடம், உத்ரட்டாதி ஆகிய நக்ஷத்திரங்களும் <hr class="orange">
  க்ருஷ்ண பக்ஷ சித்திரை, நவமி, தவிர்த்த திதிகளும் <hr class="orange">
  ரிஷபம், கடகம், வ்ருச்சிகம் ஆகிய லக்னங்களும் <hr class="orange">
  திங்கள், செவ்வாய், புதன், வியாழன் ஆகிய நாட்களும்  <hr class="orange">
  பூப்பிரவேசம் செய்ய உகந்த காரணிகளாகும்.
  
  
  
  
   

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">2. உழவு - க்ருஷி</div> </summary>
  ரோகிணி, புனர்பூசம், பூசம், உத்ரம், ஹஸ்தம்,  மூலம்,  உத்ராடம், உத்ரட்டாதி, ரேவதி ஆகிய நக்ஷத்திரங்களும் <hr class="orange">
  த்ருதியை, பஞ்சமி, ஸப்தமி, ஏகாதசி, த்ரையோதசி திதிகளும் <hr class="orange">
  ரிஷபம், மிதுனம், கடகம், மகரம், மீனம் ஆகிய லக்னங்களும் <hr class="orange">
  ஆகாச, பாதாள யோகினி இல்லாத நாட்களும்  <hr class="orange">
  உழவு செய்ய உகந்த காரணிகளாகும்.
  
  

 

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">3. விதை விதைக்க</div> </summary>
நக்ஷத்ரம் : <hr class="orange">
உத்தமம்  : ரோகிணி, பூசம், மகம், உத்ரம், ஹஸ்தம், ஸ்வாதி, அநுஷம், மூலம், உத்ராடம், திருவோணம், சதயம், உதரட்டாதி, ரேவதி <br>
மத்யமம் :  அஸ்விநி, ம்ருகசீர்ஷம், புனர்பூசம், அவிட்டம் <hr class="orange">
திதி: துவிதியை, ஷஷ்டி, தசமி <hr class="orange">
லக்னம் : ரிஷபம், கடகம், சிம்மம், மீனம் -- மத்யமம்  :  மிதுனம், துலாம்<hr class="orange">
விசேஷ விதி:  8மிடம் சுத்தம் வேண்டும், ஆகாச - பாதாள யோகினி கூடாது, <hr class="orange">
நெல் - ஞாயிற்றுக் கிழமை உதயத்திலும்,  எள் - சனி உச்சி வேளையிலும், 
கொள், வரகு செவ்யாய் உதயத்திலும் விதைக்கலாம்.


  
  

  <h3>எது செய்ய - எந்த நக்ஷத்திரம்</h3>
  
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">நக்ஷத்திரம்
  </td><td style="padding:8px; border:1px solid #e0e0e0">செய்யத்தக்க விஷயங்கள்	
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அஸ்வி
  </td><td style="padding:8px; border:1px solid #e0e0e0">தென்னை, பனை, கமுகு, மா, கரும்பு வைத்தல் , முளை தெளித்தல்
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பரணி
  </td><td style="padding:8px; border:1px solid #e0e0e0">படர் பயிர், நெல் விதைத்தல், கத்தரி நட, பயிர் குழி எடுக்க
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">கார்
  </td><td style="padding:8px; border:1px solid #e0e0e0">காடு வளர்க், பனை புதைக்க, ஆடு வாங்க
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ரோகி
  </td><td style="padding:8px; border:1px solid #e0e0e0"> வாழை மற்ற தோப்பு நட, நெல் நாற்று  நட
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ம்ருக
  </td><td style="padding:8px; border:1px solid #e0e0e0">தோப்பு வைக்க, நெல் விதை சுருணை, எருத்துப்புரை கட்ட
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">திருவா
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">உழவு மாடு வாங்குதல்</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">புனர்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">படர் கிழங்கு வகை நடுதல்</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூசம்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">வாழை, கரும்பு நட</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஆயில்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">வெற்றிலை நட</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">மகம்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">பசு வாங்க</td></tr>
  
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">உத்ர
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">கால்நடைகளுக்கு ஆகாத நக்ஷத்ரம்</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஹஸ்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">பசு மாடு வாங்க</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சித்ரை
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">பயறு வகை பயிரிட</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஸ்வா
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">பசுமாடு வாங்க
  </td></tr>
  
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அநு
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">எள் விதைக்க</td></tr>
  
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">மூலம்
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">வெற்றிலைக்கொடி நட</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூராட
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">யானை கட்ட, பசு வாங்கவும் சிறந்தது
  </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">உத்ரா
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">குதிரை, யானை வாங்க</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">திருவோ
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">எற் விதைக்க</td></tr>
  
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சதய
  </td>
  <td style="padding:8px; border:1px solid #e0e0e0">யானை கட்ட, எள் விதைக்க</td></tr>
   </table>
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">4. எரு இடுதல்</div> </summary>
நக்ஷத்ரம் : <hr class="orange">
உத்தமம்  : ரோகிணி, பூசம், மகம், உத்ரம், ஹஸ்தம், ஸ்வாதி, அநுஷம், மூலம், உத்ராடம், திருவோணம், சதயம், உதரட்டாதி, ரேவதி <br>
மத்யமம் :  அஸ்விநி, ம்ருகசீர்ஷம், புனர்பூசம், அவிட்டம் <hr class="orange">
திதி:<hr class="orange">
லக்னம் :<hr class="orange">
விசேஷ விதி:<hr class="orange">
  
  

  
  
  
  
   

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">5. கதிரறுத்தல்</div> </summary>
நக்ஷத்ரம் : பரணி, ரோகிணி, ம்ருகசீர்ஷம், திருவாதிரை, பூசம், மகம், உத்ரம், ஹஸ்தம், விசாகம், அநுஷம், உத்ராடம், திருவோணம்,  உத்ரட்டாதி, ரேவதி<br>
திதி: துவிதியை, த்ருதியை, பஞ்சமி, ஷஷ்டி, ஸப்தமி, தசமி, ஏகாதசி, துவாதசி, த்ரையோதசி, பௌர்ணமி<hr class="orange">
லக்னம் : ரிஷபம், கடகம், சிம்மம், வ்ருச்சிகம், கும்பம்<hr class="orange">
விசேஷ விதி: ஜன்ம நக்ஷத்ரம் தவிர்க்கவேண்டும்.<hr class="orange">
  
  

  

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">6.களஞ்சியத்தில் சேமிக்க</div> </summary>
  நக்ஷத்ரம் : 
பரணி, ரோகிணி, ம்ருகசீர்ஷம், திருவாதிரை, மகம், உத்ரம், ஹஸ்தம், அநுஷம், உத்ராடம், திருவோணம், உத்ரட்டாதி<br>
  திதி:  துவிதியை, த்ருதியை, பஞ்சமி,  ஸப்தமி, தசமி, ஏகாதசி, துவாதசி, த்ரையோதசி, பௌர்ணமி<hr class="orange">
  லக்னம் : ரிஷபம், மிதுனம், சிம்மம், கன்னி, வ்ருச்சிகம், தனுசு, கும்பம், மீனம்<hr class="orange">
  விசேஷ விதி: சனிக்கிழமை நன்று, சுமங்கலி அல்லது கன்னிப்பெண் செய்தல் நன்று.
  
  
  
  


 

  
  
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">7. தானியம் செலவிட</div> </summary>
  நக்ஷத்ரம் : அஸ்விநி, ரோகிணி, ம்ருகசீர்ஷம், புனர்பூசம், பூசம், மகம், உத்ரம், ஹஸ்தம், சித்ரை, ஸ்வாதி, விசாகம், அநுஷம், மூலம், உத்ராடம், திருவோணம், உத்ரட்டாதி. ரேவதி<br>
  திதி:  துவிதியை, த்ருதியை, பஞ்சமி,  ஸப்தமி, தசமி, ஏகாதசி, துவாதசி, த்ரையோதசி, பௌர்ணமி
  <hr class="orange">
  லக்னம் : ரிஷபம், மிதுனம், சிம்மம், கன்னி, வ்ருச்சிகம், தனுசு, கும்பம், மீனம்
  <hr class="orange">
  விசேஷ விதி: வெள்ளிக்கிழமை கூடாது, சனிக்கிழமை நல்லது.
   
  
  
  
  
  
   

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">8. ஆடு-மாடு வாங்க, விற்க</div> </summary>
  நக்ஷத்ரம் :  அஸ்விநி, க்ருத்திகை, ரோகிணி, புனர்பூசம், பூசம், மகம், பூரம், விசாகம், அநுஷம், மூலம், பூராடம், திருவோணம், அவிட்டம், பூரட்டாதி, ரேவதி
  <br>
  திதி: துவிதியை, த்ருதியை, பஞ்சமி, ஷஷ்டி, ஸப்தமி, தசமி, ஏகாதசி, துவாதசி, த்ரையோதசி
   <hr class="orange">
  லக்னம் : சிம்மம், தனுசு, மகரம்
  <hr class="orange">
  விசேஷ விதி:  8 மிடம் சுத்தம், மாடு கொடுத்தலுக்குப் புதன், வெள்ளிக்கிழமை கூடாது.
  
  
  
  

  

   
  </details>
<details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
<summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">9. குளம், கிணறு வெட்ட</div> </summary>
  நக்ஷத்ரம் :  ரோகிணி, பூசம், மகம், உத்ரம், ஹஸ்தம், அநுஷம், உத்ராடம், திருவோணம், அவிட்டம், சதயம், உத்ரட்டாதி, ரேவதி
  <br>
  திதி:  துவிதியை, த்ருதியை, பஞ்சமி, ஸப்தமி, தசமி,  த்ரையோதசி
  <hr class="orange">
  லக்னம் : ரிஷபம், கடகம், துலாம், வ்ருச்சிகம், மகரம், கும்பம், மீனம்
  <hr class="orange">
  விசேஷ விதி:  4மிடம் சுத்தம், பாதாள யோகினி கூடாது.
</details>
</div>




` }} />
    </div>
  );
};

export default VivasayamPage;
